<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
@if(choice().maxIngredients === 1 && this.choice().enforcedIngredients === 1){
  <cwo-expandable-component class="expandable" [expandOnClick]="false"
  [expandedInput]="initialValue && dependableChoices().length > 0" [useNonButtonHeader]="true"
  [ariaControlsName]="'Select to expand ' + ingredient().name + 'for more details'">
  <ng-template #heading>
    <div class="ingredient-name-wrapper 1" [ngClass]="{'with-dependable-choices': dependableChoices().length > 0}">
        <label class="ingredient-name" tabindex="0" role="radio"
          (keydown.space)="$event.preventDefault(); inputElement.click()"
          (keydown.enter)="inputElement.click()"
          [attr.aria-checked]="initialValue"
          [attr.aria-label]="ingredient().name + (displayedPrice() ? ', +$' + displayedPrice()?.toFixed(2) : '')">
          <span tabindex="-1" aria-hidden="true">{{ingredient().name}}</span>
          <div class="checkbox-wrapper" aria-hidden="true">
            @if(configService.configState().store?.showIngredientPricesOnOrder && displayedPrice()){
            <span class="price">+${{displayedPrice()?.toFixed(2)}}</span>
            }
            <input [style.display]="loading ? 'none' : undefined" class="themed-radio" type="radio" [checked]="initialValue"
              (change)="toggleIngredient(initialValue, inputElement, true)" #inputElement [name]="choice().name"
              [attr.aria-label]="ingredient().name + (displayedPrice() ? ' +$' + displayedPrice()?.toFixed(2) : '')"
              [attr.aria-checked]="initialValue" tabindex="-1">
            @if(loading){
            <div class="loading-radio"></div>
            }
          </div>
        </label>
      @if(dependableChoices().length > 0){
      <div>
        {{'shared_components.choices.ingredients.includes' | transloco}} @for (choice of dependableChoices(); track $index) {
        <span class="dependable-choice">{{choice.name}}@if($index !== dependableChoices().length - 1){, }</span>
        }.
      </div>
      }
    </div>
  </ng-template>
  <ng-template #content>
    <div class="expandable-content" [ngClass]="{'with-dependable-choices': dependableChoices().length > 0}" #expandableContent>
      @if(dependableChoices().length > 0){
      <div class="dependable-choices-wrapper">
        @for(dependableChoice of dependableChoices(); track $index) {
        <cwo-dependable-choice class="choice" [isSpecial]="isSpecial()" [expandedInput]="$index === 0" [choice]="dependableChoice"
          [orderedChoice]="orderedItem().getChoice(dependableChoice.name)" [orderedItem]="orderedItem()"
          [orderableItem]="orderableItem()" [firstInvalidChoice]="firstInvalidChoice()"
          (resetWarningsAfterSubmissionValue)="resetWarningsAfterSubmissionValue.emit()"
          (updateSpecialItem)="updatedSpecialItem.emit($event)" />
        }

      </div>
      }
    </div>
  </ng-template>
</cwo-expandable-component>
}
@if(!(choice().maxIngredients === 1 && this.choice().enforcedIngredients === 1)){
@if(ingredient().allowHalves || ingredient().qualifiers.length > 0) {
<cwo-expandable-component class="expandable" [expandedInput]="initialValue" [useNonButtonHeader]="true"
  [ariaControlsName]="'Select to expand ' + ingredient().name + 'for more details'">
  <ng-template #heading>
    <div
      class="tooltip-container"
      *transloco="let t"
    >
    <div class="ingredient-name-wrapper">
        <cwo-tooltip
          [visible]="!isSpecial() && initialValue && ingredient().isExtraIngredientUpsell && !this.orderableItem().isExtraIngredientTooltipOpenedOnce"
          [placement]="[tooltipPlacement.TopEnd, tooltipPlacement.BottomEnd]"
          [triggers]="'click'"
          [autoClose]="false"
          [offsetY]="20"
          [offsetX]="19"
          [arrowPadding]="275"
          [customTopPadding]="tooltipTopMargin() + 60"
          [customeBottomPadding]="dependableChoices().length > 0 ? -2 : 20"
          (tooltipClosed)="toggleTooltip(false)"
          [openTooltip]="openTooltip"
          [closeAllTooltips]="closeAllTooltips"
        >
        <label
          class="ingredient-name"
          role="checkbox"
          (click)="inputElement.toggleCheckbox($event)"
          (keydown.space)="inputElement.toggleCheckbox($event); toggleTooltip(true)"
          (keydown.enter)="inputElement.toggleCheckbox($event); toggleTooltip(true)"
          tabindex="0"
          [attr.aria-checked]="initialValue"
          [attr.aria-label]="ingredient().name + (displayedPrice() ? ', +$' + displayedPrice()?.toFixed(2) : '')"
        >
          <span tabindex="-1" aria-hidden="true">{{ingredient().name}}</span>
          <div class="checkbox-wrapper" aria-hidden="true" inert>
            @if(configService.configState().store?.showIngredientPricesOnOrder && displayedPrice()){
            <span class="price">{{'+'}}{{displayedPrice()?.toFixed(2) | currency: 'USD'}}</span>
            }
            <cwo-custom-checkbox 
              #inputElement
              [ariaLabel]="ingredient().name"
              [inputTabIndex]="-1"
              [(ngModel)]="initialValue" 
              (ngModelChange)="toggleIngredient($event, inputElement)" 
              [loading]="loading"
              [useStopPropagation]="false">
            </cwo-custom-checkbox>
          </div>
        </label>
        @if(dependableChoices().length > 0){
          <div>
            {{'shared_components.choices.ingredients.includes' | transloco}} @for (choice of dependableChoices(); track $index) {
            <span class="dependable-choice">{{choice.name}}@if($index !== dependableChoices().length - 1){, }</span>
            }.
          </div>
        }
        <ng-template #tooltipTemplate>
          <div class="tooltip-wrapper">
            <span class="tooltip-content">
              <b>{{t('shared_components.choices.ingredients.extra', { choice: ingredientUpsell()?.choice })}}</b>
              {{t('shared_components.choices.ingredients.for_only_more', { name: ingredient().name, price: ingredientUpsell()?.priceDiff?.toFixed(2) })}}
              @if(hasLoyalty && ingredientUpsell()?.pointsDiff){
              <br/>{{ t('shared_components.choices.ingredients.tooltip.earn') }} <b class="points-text">{{t('shared_components.choices.ingredients.tooltip.earn_points', { points: ingredientUpsell()?.pointsDiff })}}</b>
              }
            </span>
    
            <div class="buttons-container">
              <button class="button-accent button-white button-custom" (click)="onTooltipClose(true)">
                {{ t('shared_components.choices.ingredients.tooltip.add_it') }}
              </button>
              <button class="button-accent button-white-outlined button-custom" (click)="onTooltipClose()">
                {{ t('shared_components.choices.ingredients.tooltip.no_thanks') }}
              </button>
            </div>
          </div>
        </ng-template>
        </cwo-tooltip>
      </div>
    </div>
    
  </ng-template>
  <ng-template #content>
    <div class="expandable-content" #expandableContent>
      @if (ingredient().allowHalves) {
      <div class="half-row">
        <cwo-side-selection [orderedIngredient]="orderedIngredient" [(ngModel)]="selectedSide"
          (ngModelChange)="sideSelection($event)" [radioGroupName]="index() + ingredient().name" />
        @if (ingredient().qualifiers.length > 0) {
        <cwo-qualifier [displayStyle]="qualifierDisplayStyle()" [selectedQualifiers]="orderedIngredient?.qualifiers ?? []"
          [qualifiers]="ingredient().qualifiers" [isQualifierSelected]="initialValue"
          (qualifierChange)="toggleQualifier($event)" />
        }
      </div>
      } @else if (ingredient().qualifiers.length > 0) {
      <cwo-qualifier [displayStyle]="qualifierDisplayStyle()" [selectedQualifiers]="orderedIngredient?.qualifiers ?? []"
        [qualifiers]="ingredient().qualifiers" [isQualifierSelected]="initialValue"
        (qualifierChange)="toggleQualifier($event)" />
      }
      @if (choice().allowSecondHalves && selectedSide !== sideSelectionType.WHOLE) {
      <div class="half-row">
        <cwo-side-selection [orderedIngredient]="orderedIngredient" [(ngModel)]="selectedSecondSide"
          (ngModelChange)="secondSideSelection($event)" [radioGroupName]="index() + ingredient().name + '-second'" [allowDeselect]="true" [disableWhole]="true"
          [disableLeft]="selectedSide === sideSelectionType.LEFT" [disableRight]="selectedSide === sideSelectionType.RIGHT" />
        @if (ingredient().qualifiers.length > 0) {
        <cwo-qualifier [displayStyle]="qualifierDisplayStyle()" [selectedQualifiers]="selectedSecondHalfQualifiers"
          [qualifiers]="ingredient().qualifiers" [isQualifierSelected]="initialValue"
          (qualifierChange)="toggleSecondHalfQualifier($event)" />
        }
      </div>
      }

    </div>
    @if(dependableChoices().length > 0){
    <div class="expandable-content" [ngClass]="{'with-dependable-choices': dependableChoices().length > 0}" #expandableContent>
      <div class="dependable-choices-wrapper">
        @for(dependableChoice of dependableChoices(); track $index) {
        <cwo-dependable-choice class="choice" [isSpecial]="isSpecial()" [expandedInput]="$index === 0" [choice]="dependableChoice"
          [orderedChoice]="orderedItem().getChoice(dependableChoice.name)" [orderedItem]="orderedItem()"
          [orderableItem]="orderableItem()" [firstInvalidChoice]="firstInvalidChoice()"
          (resetWarningsAfterSubmissionValue)="resetWarningsAfterSubmissionValue.emit()"
          (updateSpecialItem)="updatedSpecialItem.emit($event)" />
        }
      </div>
    </div>
    }
  </ng-template>
</cwo-expandable-component>
} @else {
<cwo-expandable-component class="expandable" [expandOnClick]="false"
  [expandedInput]="initialValue && dependableChoices().length > 0" [useNonButtonHeader]="true"
  [ariaControlsName]="'Select to expand ' + ingredient().name + 'for more details'">
  <ng-template #heading>
    <div class="ingredient-name-wrapper 3" [ngClass]="{'with-dependable-choices': dependableChoices().length > 0}">
      <label class="ingredient-name" role="checkbox" (click)="inputElement.toggleCheckbox($event)"
      (keydown.space)="inputElement.toggleCheckbox($event)"
      (keydown.enter)="inputElement.toggleCheckbox($event)" tabindex="0"
      [attr.aria-checked]="initialValue"
      [attr.aria-label]="ingredient().name + (displayedPrice() ? ', +$' + displayedPrice()?.toFixed(2) : '')">
        <span tabindex="-1" aria-hidden="true">{{ingredient().name}}</span>
        <div class="checkbox-wrapper" aria-hidden="true" inert>
          @if(configService.configState().store?.showIngredientPricesOnOrder && displayedPrice()){
          <span class="price">+${{displayedPrice()?.toFixed(2)}}</span>
          }
          <cwo-custom-checkbox 
            #inputElement
            [ariaLabel]="ingredient().name"
            [inputTabIndex]="-1"
            [(ngModel)]="initialValue" 
            (ngModelChange)="toggleIngredient($event, inputElement)" 
            [loading]="loading">
          </cwo-custom-checkbox>
        </div>
      </label>
      @if(dependableChoices().length > 0){
      <div>
        {{'shared_components.choices.ingredients.includes' | transloco}} @for (choice of dependableChoices(); track $index) {
        <span class="dependable-choice">{{choice.name}}@if($index !== dependableChoices().length - 1){, }</span>
        }.
      </div>
      }
    </div>
  </ng-template>
  <ng-template #content>
    <div class="expandable-content" [ngClass]="{'with-dependable-choices': dependableChoices().length > 0}" #expandableContent>
      @if(dependableChoices().length > 0){
      <div class="dependable-choices-wrapper">
        @for(dependableChoice of dependableChoices(); track $index) {
        <cwo-dependable-choice class="choice" [isSpecial]="isSpecial()" [expandedInput]="$index === 0" [choice]="dependableChoice"
          [orderedChoice]="orderedItem().getChoice(dependableChoice.name)" [orderedItem]="orderedItem()"
          [orderableItem]="orderableItem()" [firstInvalidChoice]="firstInvalidChoice()"
          (resetWarningsAfterSubmissionValue)="resetWarningsAfterSubmissionValue.emit()"
          (updateSpecialItem)="updatedSpecialItem.emit($event)" />
        }

      </div>
      }
    </div>
  </ng-template>
</cwo-expandable-component>
}
}

<ng-template #tooltipContent>
  <span class="tooltip-content" *transloco="let t">
    <b>{{t('shared_components.choices.ingredients.extra' ,{ choice: ingredientUpsell()?.choice} )}}</b>{{t('shared_components.choices.ingredients.for_only_more',
    { name: ingredient().name, price: ingredientUpsell()?.priceDiff?.toFixed(2)})}}
  </span>
</ng-template>